<template>
    <yuukyuu-kanri-create />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import YuukyuukanriCreate from '@/components/yuukyuukanri/Create.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'yuukyuu-kanri-create': YuukyuukanriCreate
    }
})
</script>
